<p-toast/>
<p-confirmPopup/>


<div class="card" style="min-height: 80vh;">
    <div class="flex w-full justify-content-between">
        <span style="font-size: 20px; font-weight: bold;">
            SINAPI
        </span>
    </div>

        <hr class="w-full my-3">

        <div class="mt-4">
            <p-fileUpload #fileUploaderDrop name="sheet[]" accept=".xls,.xlsx" 
            [auto]="true" [customUpload]="true" [showUploadButton]="false" [showCancelButton]="false" [multiple]="false"
            (uploadHandler)="importFile($event)">
                <!-- Zona de arrastar/soltar -->
                <ng-template pTemplate="empty">
                <p-messages
                    [value]="[{ severity: 'info', detail: 'Insira a planilha SINAPI Formatada' }]"
                    [enableService]="false" [closable]="false" />

                <div
                    class="flex align-items-center justify-content-center flex-column p-6 border-2 border-dashed surface-border border-round cursor-pointer">
                    <i class="pi pi-cloud-upload text-5xl mb-3 text-500"></i>
                    <p class="m-0">Arraste e solte seu arquivo CSV/XLS aqui ou clique no botão acima</p>
                </div>
                </ng-template>
            </p-fileUpload>
        </div>
        
        

</div>
